import SearchModal from './components/search-modal'

export default SearchModal
